import { ReceiptPrintSelectedController as controller } from './receipt-print-selected.controller'

export const ReceiptPrintSelectedComponent = {
  template: `
  <div>
    <style ng-bind="$ctrl.receiptCSS"></style>
    <div ng-bind-html="$ctrl.renderedTemplate"></div>
  </div>
  `,
  controller,
  bindings: {
    data: '=',
    options: '=',
  },
}
